class AddToCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateCart();
  }

  updateCart() {
    const handler = async (data) => {
      const productsInput = data?.products;
      const buyTogether = data?.buyTogether;
      if (!Array.isArray(productsInput) || productsInput.length === 0) return;

      
      const config = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: productsInput.map((item) => ({
            id: item.variantId,
            quantity: item.quantity,
          })),
        }),
      };

      try {
        const response = await fetch("/cart/add.js", config);
        if (!response.ok) throw new Error("Erro ao adicionar ao carrinho");

        const result = await response.json();
        await this.updatePopup(result.items);
        await this.updateIcon();

        const products = result.items.map((item) => {
          const matchingInput = productsInput.find(
            (p) => p.variantId == item.variant_id,
          );

          return {
            id: item.product_id,
            name: item.product_title,
            variant: item.title,
            discount: item.total_discount,
            price: item.price / 100,
            quantity: item.quantity,
            brand: item.vendor,
            reference_code: matchingInput?.referenceCode || null,
          };
        });

        Shopify.analytics?.publish?.("add_to_cart_custom", { products });

        // ✅ Se for compra com buytogether, salva o atributo
        if (buyTogether === true) {
          Shopify.analytics?.publish?.("add_buy_together", { products });
          await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              attributes: {
                buytogether: "true",
              },
            }),
          });
        }
      } catch (error) {
        console.error("Erro ao adicionar ao carrinho", error);
      }
      
    };
    this.unsubscribe = subscribe(PUB_SUB_EVENTS.addToCart, handler);
  }

  async updateIcon() {
    // requisição ao carrinho shopify
    const response = await fetch('/cart.js', {
      method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
    });
    if (!response.ok) throw new Error("Erro ao buscar carrinho");
    const cart = await response.json();

    // atualizar a quantidade visual no ícone
    const iconBag = document.querySelectorAll("[data-button-bag]");
    iconBag.forEach((item) => {
      const quantityBag = item?.querySelector(".quantity_badges");
      if(quantityBag) {
        if(cart.item_count > 0) {
          quantityBag.parentElement.style.display = "block";
        } else {
          quantityBag.parentElement.style.display = "none";
        }
        quantityBag.textContent = cart.item_count;
        this.dispatchEvent(new CustomEvent("bag:open-buy-button", { bubbles: true }));
      }
    });
  }

  async updatePopup(products) {
    const modal = this.querySelector("dialog");

    const productCard = modal.querySelector(".productCard");
    const sizeProduct = modal.querySelector(".sizeProduct");
    // const successMessage = modal.querySelector(".successMessage");
    const titlePopUp = modal.querySelector(".titlePopUp");

    if(products.length > 1) {
      // successMessage.style.display = "flex";
      productCard.style.display = "none";
      titlePopUp.textContent = "Produtos adicionados á sacola"
    } else if(products.length = 1) {
      //aparecer container do produto
      productCard.style.display = "flex";
      // successMessage.style.display = "none";
      titlePopUp.textContent = "Produto adicionado á sacola"

      // atualiza os dados do produto
      products.forEach((item) => {
        //Tamanho
        sizeProduct.textContent = `Tamanho: ${item.variant_options[0]}`
      });
    }

    //aparecer o pop-up
    modal.showModal();
    const body = document.querySelector("body");
    body.style.overflow = "hidden";
    modal.style.display = "flex";

    this.closeModal();
  }

  closeModal() {
    const modal = this.querySelector("dialog");
    const body = document.querySelector("body");

    // fecha popup
    const closeModalButtons = this.querySelectorAll(".closeModalButtons");
    
    closeModalButtons.forEach((item) => {
      item.addEventListener("click", () => {
        modal.close();
      })
    })
    

    modal.addEventListener("click", (event) => {
      const rect = modal.getBoundingClientRect();
      const isClickInside =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;

      if (!isClickInside) {
        modal.close();
      }
    });

    modal.addEventListener('close', () => {
      body.style.overflow = "visible";
      modal.style.display = "none";
    });
  }

  

  disconnectedCallback() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }
}

customElements.define("add-to-cart", AddToCart);
